module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "match-score",
    style: ({
      'top': _vm.top
    })
  }, [_c('iframe', {
    staticClass: "player-score-iframe",
    attrs: {
      "src": _vm.iframeUrl,
      "frameborder": "0"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e51f8e","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/matchScore.vue
// module id = 633
// module chunks = 2